import * as React from "react";

interface VariableScopeContextData {
    key: number;
}

export const VariableScopeContext = React.createContext<VariableScopeContextData>({} as VariableScopeContextData);
